import { useRouter } from 'next/router';

export default function useRestaurantCode() {
    const router = useRouter();

    return router.query?.code;
}
